riot.tag2('markdown', '<div name="content"></div>', '', '', function(opts) {
        this.on('mount', () => {
            this.content.outerHTML = require(`../../docs/${opts.file}.md`)
        })
});



// WEBPACK FOOTER //
// ./js/tags/markdown.html